import React from 'react'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'

const RpqsOptionsApp = () => {
    useTitle(() => [{
        title: 'RPQS',
        href: 'rpqs',
    }, {
        title: i18n.options,
        href: 'rpqs/option',
    }], [])

    return (
        <div>RpqsOptions</div>
    )
}

export default RpqsOptionsApp